import React, { useCallback, useId, useState } from "react";
import { App, Form, Input, Modal } from "antd";
import { createAgentManualPublicLead } from "../../../services/publicSiteLeadsApi";

export default function CreateManualLeadModal({ open, onClose, onCreated }) {
  const { message } = App.useApp();
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const clientRequestIdBase = useId();

  const handleCancel = useCallback(() => {
    if (submitting) return;
    form.resetFields();
    onClose?.();
  }, [form, onClose, submitting]);

  const handleOk = useCallback(async () => {
    if (submitting) return;
    let values;
    try {
      values = await form.validateFields();
    } catch {
      return;
    }

    setSubmitting(true);
    try {
      const payload = {
        full_name: String(values.full_name || "").trim(),
        phone: String(values.phone || "").trim(),
        email: values.email ? String(values.email).trim() : undefined,
        interest_destination: values.interest_destination
          ? String(values.interest_destination).trim()
          : undefined,
        message: values.message ? String(values.message).trim() : undefined,
        category: values.category ? String(values.category).trim() : undefined,
        client_request_id: `${clientRequestIdBase}-${Date.now()}`,
      };
      Object.keys(payload).forEach((key) => {
        if (payload[key] === undefined || payload[key] === "") delete payload[key];
      });
      // full_name + phone required — restore after cleanup
      payload.full_name = String(values.full_name || "").trim();
      payload.phone = String(values.phone || "").trim();

      const res = await createAgentManualPublicLead(payload);
      if (!res?.success) {
        throw new Error(res?.error?.message || res?.message || "יצירת ליד נכשלה");
      }
      message.success("הליד נוצר בהצלחה");
      form.resetFields();
      onCreated?.(res.lead);
    } catch (e) {
      const apiMessage =
        e?.response?.data?.message || e?.message || "שגיאה ביצירת ליד";
      message.error(apiMessage);
    } finally {
      setSubmitting(false);
    }
  }, [clientRequestIdBase, form, message, onCreated, submitting]);

  return (
    <Modal
      title="ליד חדש"
      open={open}
      onCancel={handleCancel}
      onOk={handleOk}
      okText="צור ליד"
      cancelText="ביטול"
      confirmLoading={submitting}
      destroyOnClose
      centered
      width="min(520px, calc(100vw - 24px))"
      okButtonProps={{
        disabled: submitting,
        style: { background: "#e85d04", borderColor: "#e85d04", fontWeight: 600 },
      }}
      cancelButtonProps={{ disabled: submitting }}
      styles={{
        content: { borderRadius: 16 },
        header: { borderBottom: "1px solid #e7e5e4", marginBottom: 12 },
      }}
    >
      <Form form={form} layout="vertical" requiredMark="optional">
        <Form.Item
          name="full_name"
          label="שם מלא"
          rules={[{ required: true, message: "יש למלא שם מלא" }]}
        >
          <Input maxLength={200} placeholder="שם הלקוח" />
        </Form.Item>
        <Form.Item
          name="phone"
          label="טלפון"
          rules={[{ required: true, message: "יש למלא טלפון" }]}
        >
          <Input maxLength={64} placeholder="050-0000000" />
        </Form.Item>
        <Form.Item name="email" label="אימייל">
          <Input maxLength={254} placeholder="email@example.com" />
        </Form.Item>
        <Form.Item name="interest_destination" label="יעד להתעניינות">
          <Input maxLength={255} placeholder="למשל: קפריסין" />
        </Form.Item>
        <Form.Item name="category" label="קטגוריה">
          <Input maxLength={64} placeholder="אופציונלי" />
        </Form.Item>
        <Form.Item name="message" label="הודעה / הערה">
          <Input.TextArea maxLength={4000} rows={3} placeholder="פרטים נוספים" />
        </Form.Item>
      </Form>
    </Modal>
  );
}
